// extracted by mini-css-extract-plugin
export default {"form-control":"Input_form-control__v+bV1","invalid":"Input_invalid__otMIx"};